import { format } from 'date-fns'
import { DisasterDatum, DisasterFilter } from './types'

export function humanDate(date: Date) {
	return format(date, 'd MMM yyyy')
}

export const SEASON_START_MONTH = 9
export const SEASON_END_MONTH = 4

export const floodColor = {r:21,g:118,b:182}
export const droughtColor = {r:255,g:127,b:0}
export const flashFloodColor = {r:34,g:161,b:34}
export const stormColor = {r:149,g:100,b:191}
export const landslideColor = {r:217,g:37,b:31}
export const hailColor = {r:0,g:190,b:209}
export const erosionColor = {r:141,g:86,b:73}

export function filterFunc(d: DisasterDatum, disasterFilter: DisasterFilter) {
	if (
		(d.typeCode === 12301 || d.typeCode === 12303) &&
		disasterFilter.floods
	) {
		return true
	}
	if (d.typeCode === 12302 && disasterFilter.flashFloods) {
		return true
	}
	if (
		(d.typeCode === 12401 || d.typeCode === 12402) &&
		disasterFilter.drought
	) {
		return true
	}
	if (d.typeCode === 12205 && disasterFilter.hail) {
		return true
	}
	if (
		(d.typeCode === 12101 ||
			d.typeCode === 12102 ||
			d.typeCode === 12103 ||
			d.typeCode === 12104 ||
			d.typeCode === 12304) &&
		disasterFilter.storms
	) {
		return true
	}
	if (
		(d.typeCode === 13301 ||
			d.typeCode === 13302 ||
			d.typeCode === 13303 ||
			d.typeCode === 13304) &&
		disasterFilter.landslide
	) {
		return true
	}
	if (
		(d.typeCode === 13305 ||
			d.typeCode === 13306 ||
			d.typeCode === 13308 ||
			d.typeCode === 13309) &&
		disasterFilter.erosion
	) {
		return true
	}
	if (d.typeCode === 12206 && disasterFilter.frost) {
		return true
	}
	return false
}

export function disasterColorFunc(d: DisasterDatum) {
	if (
		(d.typeCode === 12301 || d.typeCode === 12303) 
	) {
		return floodColor
	}
	if (d.typeCode === 12302) {
		return flashFloodColor
	}
	if (
		(d.typeCode === 12401 || d.typeCode === 12402) 
	) {
		return droughtColor
	}
	if (d.typeCode === 12205 ) {
		return hailColor
	}
	if (
		(d.typeCode === 12101 ||
			d.typeCode === 12102 ||
			d.typeCode === 12103 ||
			d.typeCode === 12104 ||
			d.typeCode === 12304)
	) {
		return stormColor
	}
	if (
		(d.typeCode === 13301 ||
			d.typeCode === 13302 ||
			d.typeCode === 13303 ||
			d.typeCode === 13304) 
	) {
		return landslideColor
	}
	if (
		(d.typeCode === 13305 ||
			d.typeCode === 13306 ||
			d.typeCode === 13308 ||
			d.typeCode === 13309) 
	) {
		return erosionColor
	}
	return null
}

export function getDisastersColor(disasters: DisasterDatum[]) {
	let r = 0, g=0, b=0
	disasters.map(disasterColorFunc).forEach(d => {
		if(d !== null) {
			r += d.r/disasters.length
			g += d.g/disasters.length
			b += d.b/disasters.length
		}
	})
	return `rgb(${r},${g},${b})`
}